import { render } from "./SkeletonProfileSet.vue?vue&type=template&id=fe4d3b22"
import script from "./SkeletonProfileSet.vue?vue&type=script&lang=js"
export * from "./SkeletonProfileSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__